
import { Component, Emit, Vue } from "vue-property-decorator";

@Component
export default class AppraiserValuationFooter extends Vue {
  @Emit("delete") delete() {}
}
